/**
 * FAQ Block — Single-expand accordion
 *
 * Handles [data-faq-single] containers with collapsible panels.
 */

import { initCollapsible } from './collapsible.js';

export function initFaq() {
  initCollapsible('[data-faq-single]', '.faq-block__trigger', { singleExpand: true });
}
